export default (props = {}) => <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="vuesax/linear/tick-square">
<g id="tick-square">
<path id="Vector" d="M18 44.001H30C40 44.001 44 40.001 44 30.001V18.001C44 8.00098 40 4.00098 30 4.00098H18C8 4.00098 4 8.00098 4 18.001V30.001C4 40.001 8 44.001 18 44.001Z" stroke="#F59332" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M15.5 23.9998L21.16 29.6598L32.5 18.3398" stroke="#F59332" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
